import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import {
    contactMoreInformation,
    contactResearchAssistant,
    deviceRegister, recordActivity
} from '../slices/register'
import useCheckMobileScreen from "../common/useCheckMobileScreen";

const Landing = (props) => {
    const dispatch = useDispatch();
    const {error, loading} = useSelector(state => ({
        ...state
    }));

    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(recordActivity(deviceId, {
            action: "survey",
            page_id: "0-2"
        }))
    }, [dispatch, sessionStorage, recordActivity])

    document.title = "Study Information";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5  justify-content-center">
                        <Col className="p-0" xl={8} md={10} sm={12}>
                            <div className="text-center mt-2">
                                <h3>Telehealth for Problems with Opioid Use</h3>
                            </div>
                            <Card className="p-2 mt-4">
                                <CardBody className="p-4" id="scrollItem">

                                    <Row className="justify-content-center">
                                        <Col className="pr-5 pl-5" xl={10} md={10} sm={12}><>
                                            <h5 className="text-center">
                                                <strong>Please scroll down to read all information and click Next</strong>
                                            </h5>
                                            <br/>
                                            <ul>
                                                <li>
                                                    <p><b>This study is designed for people who are interested in treatment
                                                        for their opioid use.</b></p>
                                                </li>
                                                <li><p>This study is intended for individuals who receive medical care in
                                                    CT
                                                    and NY.
                                                </p></li>
                                                <li><p>The purpose of the research is to evaluate how well an investigational telehealth platform RecoveryPad works in providing treatment for opioid use disorder compared to usual referral practices.</p></li>
                                                <li><p>We will start by asking you some questions, and then, if you're
                                                    eligible for the study, we will ask for your consent.
                                                </p></li>
                                                <li><p>Participation is voluntary.</p></li>
                                                <li><p>The only likely risk or discomfort for participating is emotional
                                                    distress caused by answering questions about your drug use and
                                                    the negative consequences related to it.
                                                </p></li>
                                                <li><p>All records identifying you will be maintained for 3 years after the
                                                    project.
                                                </p></li>
                                                <li><p>At this time, you are not yet consenting to participate in the
                                                    project.
                                                    If you are eligible, we will provide a detailed description of the
                                                    study.
                                                </p></li>
                                                <li><p>If you are eligible, we will provide a detailed description of the study and your options, and then you can decide whether to participate.</p></li>
                                                <li><p>The only reasonably foreseeable risks or discomforts to you
                                                    for
                                                    participating in the screen is perhaps emotional distress
                                                    caused
                                                    from
                                                    answering questions about your drug use and negative
                                                    consequences
                                                    related to
                                                    it.
                                                </p></li>
                                                <li><p>Refusal to participate will involve no penalty or loss of
                                                    benefits to
                                                    which
                                                    you are otherwise entitled.
                                                </p></li>
                                                <li><p>You may contact the research team for questions, concerns,
                                                    or
                                                    complaints
                                                    about the research (Dr. Rebekah Heckmann, MD, (203) 212-9425).</p></li>
                                                <li><p>You may contact someone independent of the research team
                                                    for questions, concerns, or complaints about the research;
                                                    questions about the subjects’ rights; to obtain information;
                                                    or to offer input (WCG Institutional Review Board, (855) 818-2289).</p></li>
                                            </ul>
                                        </>
                                        </Col>
                                        <Col className="pr-5 pl-5" xl={10} md={10} sm={12}>
                                            <div className="mt-4">
                                                <Button aria-label={"next"}
                                                        disabled={error ? null : loading ? true : false}
                                                        className="btn button-primary pull-right" type="button"
                                                        onClick={() => {
                                                            props.router.navigate('/study-information-2')
                                                        }}>
                                                    Next
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(Landing);
